module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-down.f8f13e37.svg";